import React from 'react';
import { Skeleton as UISkeleton } from '@npm-registry/eapteka-ui';
import styles from './Skeleton.scss';
import clsx from 'clsx';

export const Skeleton = () => {
  return (
    <div className={styles.root}>
      <UISkeleton
        className={styles.skeleton}
        height="3em"
      />
      <UISkeleton
        className={clsx([
          styles.skeleton,
          styles.skeletonButton
        ])}
        height="2.5em"
      />
    </div>
  );
};
